import { PatronNavData, System } from 'src/app/models';

export const navItemsV2: PatronNavData[] = [
  // ── Dashboard ──────────────────────────────────────────────────────
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'bi-speedometer2',
  },

  // ── Cadastros ──────────────────────────────────────────────────────
  {
    name: 'Cadastros',
    icon: 'bi-card-list',
    onlyCompanyUsers: true,
    children: [
      {
        name: 'Pessoas',
        icon: 'bi-people-fill',
        children: [
          {
            name: 'Clientes',
            url: '/v3ndor/clientes',
            icon: 'bi-person-check-fill',
            requiredModules: ['Customers'],
            onlyCompanyUsers: true,
          },
          {
            name: 'Fornecedores',
            url: '/v3ndor/fornecedores',
            icon: 'bi-truck',
            requiredModules: ['Providers'],
            onlyCompanyUsers: true,
          },
          {
            name: 'Vendedores',
            url: '/v3ndor/vendedores',
            icon: 'bi-person-badge',
            requiredModules: ['Sellers'],
            onlyCompanyUsers: true,
          },
          {
            name: 'Transportadores',
            url: '/v3ndor/transportadores',
            icon: 'bi-truck-flatbed',
            requiredModules: ['Transporter'],
            onlyCompanyUsers: true,
          },
          {
            name: 'Compradores',
            url: '/v3ndor/compradores',
            icon: 'bi-cart-check',
            requiredModules: ['Purchasers'],
            onlyCompanyUsers: true,
          },
          {
            name: 'Clientes/Prospects',
            url: '/v3ndor/prospects',
            icon: 'bi-person-plus',
            requiredModules: ['CrmDeals'],
            checkCanWrite: true,
            onlyCompanyUsers: true,
          },
        ],
      },
      {
        name: 'Financeiro',
        icon: 'bi-cash-stack',
        children: [
          {
            name: 'Contas',
            url: '/v3ndor/contas',
            icon: 'bi-bank',
            requiredModules: ['Accounts'],
            onlyCompanyUsers: true,
          },
          {
            name: 'Centros de custo',
            url: '/v3ndor/centros-de-custo',
            icon: 'bi-pie-chart-fill',
            requiredModules: ['CostCenter'],
            onlyCompanyUsers: true,
          },
          {
            name: 'Métodos de pagamento',
            url: '/v3ndor/metodos-de-pagamento',
            icon: 'bi-credit-card-fill',
            requiredModules: ['PaymentMethod'],
            onlyCompanyUsers: true,
          },
          {
            name: 'Condições de pagamento',
            url: '/v3ndor/condicoes-pagamento',
            icon: 'bi-calendar-check',
            requiredModules: ['PaymentConditions'],
            onlyCompanyUsers: true,
          },
          {
            name: 'Categorias de financeiro',
            url: '/v3ndor/categorias-financeiro',
            icon: 'bi-bookmark',
            requiredModules: ['Category'],
            onlyCompanyUsers: true,
          },
          {
            name: 'Links de pagamento',
            url: '/links-pagamento',
            icon: 'bi-link-45deg',
            requiredModules: ['PaymentLinks'],
            onlyCompanyUsers: true,
          },
        ],
      },
      {
        name: 'Itens e Serviços',
        icon: 'bi-box-seam',
        children: [
          {
            name: 'Cadastro de itens',
            url: '/v3ndor/items',
            icon: 'bi-card-checklist',
            requiredModules: ['Items'],
          },
          {
            name: 'Cadastro de serviços',
            url: '/v3ndor/itens-servico',
            icon: 'bi-tools',
            requiredModules: ['Items'],
          },
          {
            name: 'Manutenção (integração)',
            url: '/itens/manutencao',
            icon: 'bi-wrench-adjustable',
            requiredModules: ['ItemsMaintenance'],
          },
          {
            name: 'Tipos de variações',
            url: '/v3ndor/tipos-variacoes',
            icon: 'bi-layers',
            requiredModules: ['Grids'],
          },
          {
            name: 'Tabelas de preços',
            url: '/v3ndor/tabelas-preco',
            icon: 'bi-currency-dollar',
            requiredModules: ['PriceTable'],
          },
          {
            name: 'Famílias',
            url: '/v3ndor/familias',
            icon: 'bi-collection',
            requiredModules: ['Family'],
          },
          {
            name: 'Grupos Fiscais',
            url: '/v3ndor/grupo-fiscal',
            icon: 'bi-receipt-cutoff',
            requiredModules: ['FiscalGroups'],
            onlyCompanyUsers: true,
          },
          {
            name: 'Grupos',
            url: '/v3ndor/grupos',
            icon: 'bi-collection-fill',
            requiredModules: ['Group'],
            onlyCompanyUsers: true,
          },
          {
            name: 'Subgrupos',
            url: '/v3ndor/subgrupos',
            icon: 'bi-collection-fill',
            requiredModules: ['SubGroup'],
            onlyCompanyUsers: true,
          },
          {
            name: 'Marcas',
            url: '/v3ndor/marcas',
            icon: 'bi-award',
            requiredModules: ['Brand'],
            onlyCompanyUsers: true,
          },
          {
            name: 'Tipos',
            url: '/v3ndor/tipos',
            icon: 'bi-tag-fill',
            requiredModules: ['ItemType'],
            onlyCompanyUsers: true,
          },
          {
            name: 'Subtipos',
            url: '/v3ndor/subtipos',
            icon: 'bi-tags-fill',
            requiredModules: ['ItemSubType'],
            onlyCompanyUsers: true,
          },
          {
            name: 'Controles',
            url: '/v3ndor/controles',
            icon: 'bi-shield-check',
            requiredModules: ['ItemControl'],
            onlyCompanyUsers: true,
          },
        ],
      },
      {
        name: 'Parâmetros fiscais',
        icon: 'bi-receipt',
        children: [
          {
            name: 'Operações fiscais',
            url: '/v3ndor/operacoes-fiscais',
            icon: 'bi-calculator-fill',
            requiredModules: ['FiscalOperations'],
            onlyCompanyUsers: true,
          },
          {
            name: 'Situações fiscais',
            url: '/v3ndor/situacoes-fiscais',
            icon: 'bi-pie-chart-fill',
            requiredModules: ['FiscalSituations'],
            onlyCompanyUsers: true,
          },
          {
            name: 'Observações',
            url: '/v3ndor/observacoes',
            icon: 'bi-sticky-fill',
            requiredModules: ['Observations'],
            onlyCompanyUsers: true,
          },
        ],
      },
    ],
  },

  // ── PEDIDOS ────────────────────────────────────────────────────────
  {
    name: 'Vendas',
    icon: 'bi-cart-check-fill',
    children: [
      {
        name: 'Catálogo',
        url: '/itens/catalogo',
        icon: 'bi-grid-3x3-gap',
        requiredModules: ['Catalog'],
      },
      {
        name: 'Pedidos',
        url: '/v3ndor/pedidos',
        icon: 'bi-receipt-cutoff',
        requiredModules: ['Orders'],
      },
      {
        name: 'Contratos',
        url: '/v3ndor/contratos',
        icon: 'bi-file-earmark-medical',
        requiredModules: ['Contract'],
      },
      {
        name: 'PDV',
        url: '/v3ndor/pdv',
        icon: 'bi-shop',
        requiredModules: ['PDV'],
        onlyCompanyUsers: true,
      },
      {
        name: 'Orçamentos',
        url: '/v3ndor/orcamentos',
        icon: 'bi-receipt',
        requiredModules: ['Budgets'],
      },
      {
        name: 'Vendas Perdidas',
        url: '/v3ndor/vendas-perdidas',
        icon: 'bi-x-circle',
        requiredModules: ['LostSales'],
      },
      {
        name: 'Notas fiscais',
        url: '/v3ndor/notas-fiscais',
        icon: 'bi-file-earmark-text',
        requiredModules: ['Invoices'],
      },
      {
        name: 'Notas inutilizadas',
        url: '/v3ndor/notas-inutilizadas',
        icon: 'bi-x-circle',
        requiredModules: ['Invoices'],
        onlyCompanyUsers: true,
      },
    ],
  },
  {
    name: 'Compras',
    icon: 'bi-cart-plus-fill',
    requiredModules: ['PurchaseOrders'],
    children: [
      {
        name: 'Pedidos',
        url: 'v3ndor/compras/pedidos',
        icon: 'bi-receipt-cutoff',
        requiredModules: ['PurchaseOrders'],
      },
    ],
  },

  {
    name: 'Devoluções',
    icon: 'bi-cart-plus-fill',
    requiredModules: ['Orders'],
    children: [
      {
        name: 'Pedidos',
        url: '/v3ndor/devolucoes',
        icon: 'bi-receipt-cutoff',
        requiredModules: ['Orders'],
      },
    ],
  },

  // ── FINANCEIRO ─────────────────────────────────────────────────────
  {
    name: 'Financeiro',
    icon: 'bi-bank2',
    children: [
      {
        name: 'Parcelas',
        url: '/v3ndor/financeiros',
        icon: 'bi-cash-stack',
        requiredModules: ['Launchs'],
      },
      {
        name: 'Contas a pagar',
        url: '/v3ndor/a-pagar',
        icon: 'bi-arrow-return-right',
        requiredModules: ['Installments', 'Launchs'],
      },
      {
        name: 'Contas a receber',
        url: '/v3ndor/a-receber',
        icon: 'bi-arrow-return-left',
        requiredModules: ['Installments', 'Launchs'],
      },
      {
        name: 'Movimento de contas',
        url: '/v3ndor/movimento-contas',
        icon: 'bi-arrow-left-right',
        requiredModules: ['CheckingAccount'],
        onlyCompanyUsers: true,
      },
      {
        name: 'Realizado',
        url: '/v3ndor/realizado',
        icon: 'bi-diagram-3',
        requiredModules: ['FinancialSummary'],
        onlyCompanyUsers: true,
      },
    ],
  },
  // ── ESTOQUE ───────────────────────────────────────────────────────
  {
    name: 'Estoque',
    icon: 'bi-boxes',
    children: [
      {
        name: 'Movimentação de Itens',
        url: '/v3ndor/movimentacao-itens',
        icon: 'bi-arrow-left-right',
        requiredModules: ['StockMovement'],
      },
      {
        name: 'Inventários',
        url: '/v3ndor/inventarios',
        icon: 'bi-clipboard-check',
        requiredModules: ['Inventory'],
      },
    ],
  },

  // ── CRM ────────────────────────────────────────────────────────────
  {
    name: 'CRM',
    icon: 'bi-people-fill',
    children: [
      {
        name: 'Análise',
        url: '/crm/analise',
        icon: 'bi-graph-up',
        requiredModules: ['CrmAnalysis'],
      },
      {
        name: 'Forecasting',
        url: '/crm/forecasting',
        icon: 'bi-graph-up-arrow',
        requiredModules: ['CrmForecast'],
      },
      {
        name: 'Agenda',
        url: '/crm/agenda',
        icon: 'bi-calendar-event',
        requiredModules: ['Crm'],
      },
      {
        name: 'Negociações',
        url: '/crm/negociacoes',
        icon: 'bi-person-lines-fill',
        requiredModules: ['CrmDeals'],
      },
      {
        name: 'Negociações Kanban',
        url: '/crm/negociacoes-kanban',
        icon: 'bi-kanban-fill',
        requiredModules: ['CrmDeals'],
      },
      {
        name: 'Buscar empresas',
        url: '/crm/buscar-empresas',
        icon: 'bi-building-add',
        requiredModules: ['CrmSearchCompanies'],
      },
      {
        name: 'Buscar clientes',
        url: '/v3ndor/busca-clientes',
        icon: 'bi-person-plus-fill',
        requiredModules: ['CrmSearchCustomers'],
      },
      {
        name: 'Conexões societárias',
        url: '/crm/conexoes-societarias',
        icon: 'bi-diagram-3-fill',
        requiredModules: ['CrmCorporateConnections'],
      },
      {
        name: 'Explorar mercados',
        url: '/crm/explorar-mercados',
        icon: 'bi-globe',
        requiredModules: ['CrmMarketExplorer'],
      },
      {
        name: 'Atualização de informações',
        url: '/crm/atualizacao-informacoes',
        icon: 'bi-person-gear',
        requiredModules: ['CrmImportInfo'],
      },
      {
        name: 'Origens',
        url: '/crm/origens',
        icon: 'bi-geo-alt',
        requiredModules: ['CrmOrigins'],
      },
      {
        name: 'Estratégias',
        url: '/crm/estrategias',
        icon: 'bi-lightbulb',
        requiredModules: ['Strategies'],
      },
      {
        name: 'Enquetes',
        url: '/crm/enquetes',
        icon: 'bi-chat-dots-fill',
        requiredModules: ['CrmPolls'],
      },
      {
        name: 'Pipelines',
        url: '/crm/pipelines',
        icon: 'bi-funnel',
        requiredModules: ['CrmPipelines'],
      },
      {
        name: 'Estágios',
        url: '/crm/estagios',
        icon: 'bi-bar-chart-steps',
        requiredModules: ['ContactStatuses'],
      },
      {
        name: 'Tipos de contato',
        url: '/crm/tipos-contato',
        icon: 'bi-telephone-fill',
        requiredModules: ['ContactTypes'],
      },
      {
        name: 'Objeções',
        url: '/crm/objecoes',
        icon: 'bi-exclamation-triangle',
        requiredModules: ['CrmObjections'],
      },
      {
        name: 'Motivos de Perda',
        url: '/crm/motivos-perda',
        icon: 'bi-x-circle',
        requiredModules: ['CrmReasons'],
      },
      {
        name: 'Status de Negociação',
        url: '/crm/status-negociacao',
        icon: 'bi-flag-fill',
        requiredModules: ['CrmNegotiationStatuses'],
      },
      {
        name: 'Importar negociações',
        url: '/crm/importacoes',
        icon: 'bi-database-fill-up',
        requiredModules: ['CrmImportCompanies', 'CrmImportCustomers', 'CrmImportInfo'],
      },
      {
        name: 'Ações em massa',
        url: '/crm/acoes-massa',
        icon: 'bi-lightning-charge',
        requiredModules: ['LoteMassive'],
      },
    ],
  },

  {
    name: 'Análise Cadastral',
    icon: 'bi-clipboard-data-fill',
    requiredModules: ['PersonCadastralAnalysis'],
    systems: [System.CUSTOMERS, System.V3NDOR, System.VENDOR],
    children: [
      {
        name: 'Dashboard',
        url: '/analise-cadastral/dashBoard',
        icon: 'bi-speedometer2',
      },
      {
        name: 'Lista',
        url: '/analise-cadastral/lista',
        icon: 'bi-list-check',
      },
      {
        name: 'Esteiras',
        url: '/analise-cadastral/esteiras',
        icon: 'bi-layout-three-columns',
      },
    ],
  },
  // ── MARKETING ──────────────────────────────────────────────────────
  {
    name: 'Marketing',
    icon: 'bi-megaphone-fill',
    onlyCompanyUsers: true,
    children: [
      {
        name: 'Campanhas',
        url: '/marketing/campanhas',
        icon: 'bi-megaphone-fill',
        requiredModules: ['Campaign'],
        onlyCompanyUsers: true,
      },
      {
        name: 'Listas de contatos',
        url: '/marketing/listas',
        icon: 'bi-people-fill',
        requiredModules: ['ContactList'],
        onlyCompanyUsers: true,
      },
      {
        name: 'Templates',
        url: '/marketing/templates',
        icon: 'bi-file-earmark-text',
        requiredModules: ['Campaign'],
        onlyCompanyUsers: true,
      },
      {
        name: 'Serviços de envio',
        url: '/marketing/servicos-de-envio',
        icon: 'bi-gear-fill',
        requiredModules: ['SendService'],
        onlyCompanyUsers: true,
      },
    ],
  },

  // ── SUPORTE ────────────────────────────────────────────────────────
  {
    name: 'Chamados',
    icon: 'bi-ticket-detailed-fill',
    systems: [System.TICKET_CENTER],
    children: [
      // {
      //   name: 'Sprint',
      //   url: '/chamados/sprint',
      //   icon: 'bi-calendar-week',
      //   requiredModules: ['Sprint'],
      //   onlyCompanyUsers: true,
      // },
      {
        name: 'Sprint',
        url: '/v3ndor/sprint',
        icon: 'bi-calendar-week',
        requiredModules: ['Sprint'],
        onlyCompanyUsers: true,
      },
      {
        name: 'Vistos recentemente',
        url: '/chamados/vistos-recentemente',
        icon: 'bi-clock-history',
        requiredModules: ['RecentTickets'],
        onlyCompanyUsers: true,
      },
      {
        name: 'Novo Chamado',
        url: '/v3ndor/chamados/novo',
        icon: 'bi-plus-circle-fill',
        requiredModules: ['Tickets'],
        checkCanWrite: true,
        onlyCompanyUsers: true,
      },
      {
        name: 'Histórico de apontamentos',
        url: '/chamados/apontamentos/historico',
        icon: 'bi-clock-fill',
        requiredModules: ['AppointmentHistory'],
        onlyCompanyUsers: true,
      },
      {
        name: 'Lista',
        url: '/v3ndor/chamados',
        icon: 'bi-list-ul',
        requiredModules: ['Tickets'],
        onlyCompanyUsers: true,
      },
      {
        name: 'Assistente de atualização',
        url: '/chamados/atualizacoes',
        icon: 'bi-robot',
        requiredModules: ['UpdateAssistant'],
        onlyCompanyUsers: true,
      },
    ],
  },
  {
    name: 'Teo Wiki',
    icon: 'bi-book',
    onlyCompanyUsers: true,
    children: [
      {
        name: 'Projetos',
        url: '/teo-wiki/projetos',
        icon: 'bi-folder2-open',
        requiredModules: ['BwProject'],
        onlyCompanyUsers: true,
      },
      {
        name: 'Documentações',
        url: '/teo-wiki/documentacoes',
        icon: 'bi-journal-text',
        requiredModules: ['Documentation'],
        onlyCompanyUsers: true,
      },
      {
        name: 'Explorar Documentações',
        url: '/teo-wiki/explorar',
        icon: 'bi-diagram-3',
        requiredModules: ['Documentation'],
        onlyCompanyUsers: true,
      },
      {
        name: 'Gerenciar Paths',
        url: '/teo-wiki/gerenciar-paths',
        icon: 'bi-folder-symlink',
        requiredModules: ['Documentation'],
        onlyCompanyUsers: true,
      },
      {
        name: 'Templates',
        url: '/teo-wiki/templates',
        icon: 'bi-layout-text-sidebar',
        requiredModules: ['DocTemplate'],
        onlyCompanyUsers: true,
      },
    ],
  },
  // ── ADMINISTRAÇÃO ──────────────────────────────────────────────────
  {
    name: 'Acessos',
    icon: 'bi-shield-lock-fill',
    children: [
      {
        name: 'Usuários',
        url: '/usuarios',
        icon: 'bi-people-fill',
        requiredModules: ['Users'],
        onlyCompanyUsers: true,
      },
      {
        name: 'Perfis',
        url: '/perfis',
        icon: 'bi-key-fill',
        requiredModules: ['Users'],
        onlyCompanyUsers: true,
      },
      {
        name: 'Usuários pendentes',
        url: '/usuarios-pendentes',
        icon: 'bi-person-x',
        requiredModules: ['Users'],
        systems: [System.CUSTOMERS, System.QUOTES],
        onlyCompanyUsers: true,
      },
      {
        name: 'Sessões ativas',
        url: '/sessoes',
        icon: 'bi-display-fill',
        requiredModules: ['Sessions'],
        onlyCompanyUsers: true,
      },
      {
        name: 'Licenças',
        url: '/licenses',
        icon: 'bi-card-checklist',
        requiredModules: ['RegisteredSystems'],
      },
      {
        name: 'Licenças de usuário',
        url: '/licencas-usuario',
        icon: 'bi-person-badge',
        requiredModules: ['Licenses'],
        onlyCompanyUsers: true,
      },
      {
        name: 'Termos de consentimento',
        url: '/consents',
        icon: 'bi-shield-check',
        onlyCompanyUsers: true,
        requiredModules: ['LGPDConsents'],
      },
      {
        name: 'Departamentos',
        url: '/departamentos',
        icon: 'bi-building',
        requiredModules: ['Departments'],
        onlyCompanyUsers: true,
      },
      {
        name: 'Avisos',
        url: '/avisos',
        icon: 'bi-megaphone-fill',
        requiredModules: ['Notices'],
        onlyCompanyUsers: true,
      },
    ],
  },
  {
    // Cadastros de IA e execuções (chamado 0000579137). Aparece com QUALQUER módulo Ai*.
    name: 'IA',
    icon: 'bi-robot',
    requiredModules: [
      'AiProviders',
      'AiModels',
      'AiAgents',
      'AiSkills',
      'AiPipelines',
      'AiTriggers',
    ],
    needAllModules: false,
    systems: [System.TICKET_CENTER],
    children: [
      {
        name: 'Provedores e modelos',
        url: '/ia/provedores',
        icon: 'bi-hdd-network',
        requiredModules: ['AiProviders'],
      },
      {
        name: 'Agentes',
        url: '/ia/agentes',
        icon: 'bi-person-gear',
        requiredModules: ['AiAgents'],
      },
      { name: 'Skills', url: '/ia/skills', icon: 'bi-lightning', requiredModules: ['AiSkills'] },
      {
        name: 'Pipelines',
        url: '/ia/pipelines',
        icon: 'bi-diagram-3',
        requiredModules: ['AiPipelines'],
      },
      {
        name: 'Gatilhos',
        url: '/ia/gatilhos',
        icon: 'bi-bullseye',
        requiredModules: ['AiTriggers'],
      },
      {
        name: 'Execuções',
        url: '/ia/execucoes',
        icon: 'bi-clock-history',
        requiredModules: ['AiPipelines'],
      },
      {
        name: 'Consumo',
        url: '/ia/consumo',
        icon: 'bi-wallet2',
        requiredModules: ['AiPipelines'],
      },
      {
        name: 'Avaliações',
        url: '/ia/avaliacoes',
        icon: 'bi-hand-thumbs-up',
        requiredModules: ['AiPipelines'],
      },
    ],
  },
  {
    name: 'Manager',
    icon: 'bi-display',
    requiredModules: ['Manager'],
    systems: [System.TICKET_CENTER],
    children: [
      {
        name: 'Sistemas registrados',
        url: '/manager/sistemas-registrados',
        icon: 'bi-display',
      },
      {
        name: 'Grupos de Empresas',
        url: '/manager/company-groups',
        icon: 'bi-building',
      },
    ],
  },
  {
    // Chamado 0000580000 — menu próprio, fora do Manager, para não depender do módulo Manager e
    // receber outras telas de integração depois.
    name: 'Integração',
    icon: 'bi-plug',
    requiredModules: ['IntegrationAdmin'],
    systems: [System.TICKET_CENTER],
    children: [
      {
        name: 'Central de integrações',
        url: '/integracao/central',
        icon: 'bi-diagram-3',
      },
    ],
  },
  {
    name: 'Auditoria',
    icon: 'bi-journal-text',
    children: [
      {
        name: 'API Logs',
        url: '/auditoria/api-logs',
        icon: 'bi-file-text',
        requiredModules: ['ApiLogs'],
      },
      {
        name: 'Emails Enviados',
        url: '/auditoria/sent-emails',
        icon: 'bi-envelope-check',
        requiredModules: ['AuditSentEmails'],
      },
    ],
  },
  // ── RELATÓRIOS ─────────────────────────────────────────────────────
  {
    name: 'Relatórios',
    icon: 'bi-bar-chart-fill',
    needAllModules: false,
    children: [
      {
        name: 'Conta Corrente',
        url: '/relatorios/conta-corrente',
        icon: 'bi-wallet2',
        requiredModules: ['Reports', 'CheckingAccountReports'],
      },
      {
        name: 'Vendas no periodo',
        url: '/relatorios/vendas-periodo',
        icon: 'bi-graph-up-arrow',
        requiredModules: ['Reports'],
      },
      {
        // Modulo proprio, e nao o `Reports` generico: como este grupo nao usa o
        // campo `systems`, reusar `Reports` faria o boletim aparecer tambem nos
        // paineis crm e praxis, para clientes que nao o pediram.
        name: 'Frente de Caixa',
        url: '/relatorios/frente-de-caixa',
        icon: 'bi-cash-coin',
        requiredModules: ['CashierReports'],
      },
    ],
  },

  {
    name: 'SAC',
    url: '/sac',
    icon: 'bi-headset',
    requiredModules: ['Tickets'],
  },
  {
    name: 'Roadmap',
    url: '/roadmap-chamados',
    icon: 'bi-kanban-fill',
    requiredModules: ['Roadmap'],
    onlyCompanyUsers: true,
    systems: [System.TICKET_CENTER],
  },

  // ── COTAÇÕES ───────────────────────────────────────────────────────
  {
    name: 'Cotações gerente',
    url: '/cotacoes-gerente',
    icon: 'bi-clipboard-data',
    requiredModules: ['PurchaseQuote'],
    onlyCompanyUsers: true,
  },
  {
    name: 'Cotações fornecedor',
    url: '/cotacoes-fornecedor',
    icon: 'bi-clipboard-check',
    requiredModules: ['PurchaseQuote'],
    onlySupplierUsers: true,
  },

  // ── FERRAMENTAS ────────────────────────────────────────────────────
  {
    name: 'Importar/Exportar',
    url: '/importar-exportar',
    icon: 'bi-arrow-left-right',
    requiredModules: ['ImportExportVendor'],
  },
  {
    name: 'Histórico de Movimentos',
    url: '/historico-movimentos',
    icon: 'bi-clock-history',
    requiredModules: ['PurchaseQuote'],
    onlySupportUsers: true,
  },
  {
    name: 'Rotas',
    url: '/rotas',
    icon: 'bi-map-fill',
    requiredModules: ['Routes'],
  },
  {
    name: 'Dispositivos',
    url: '/dispositivos',
    icon: 'bi-phone-fill',
    requiredModules: ['DevicesRegistered'],
    onlyCompanyUsers: true,
  },
  {
    name: 'Arquivos',
    url: '/arquivos',
    icon: 'bi-folder-fill',
    onlyCompanyUsers: true,
    requiredModules: ['Assets'],
  },
  {
    name: 'Notificações',
    url: '/notificacoes',
    icon: 'bi-bell-fill',
    requiredModules: ['Notifications'],
  },

  {
    name: 'Documentações',
    url: '/documentacoes',
    icon: 'bi-journal-text',
    onlySupportUsers: true,
    requiredModules: [],
    systems: [System.INTEGRATOR],
  },
  {
    // Chamado 0000580000 — central de integrações do cliente. Fora do Ticket Center, onde a
    // Teorema usa Integração > Central de integrações.
    name: 'Integrações',
    url: '/integracoes',
    icon: 'bi-plug',
    requiredModules: ['IntegrationPanel'],
    onlyCompanyUsers: true,
    systems: [System.MULTIPANEL, System.INTEGRATOR, System.V3NDOR, System.VENDOR],
  },
  {
    name: 'Configurações',
    url: '/configuracoes',
    icon: 'bi-gear-wide-connected',
    requiredModules: [
      'CONFIGURATIONS',
      'GeneralSettings',
      'RocketSettings',
      'QuickFilterSettings',
      'StockSettings',
      'DropshipSettings',
      'EmailSettings',
      'Integrations',
      'FilterSettings',
      'ParameterSettings',
    ],
    position: 'bottom',
    needAllModules: false,
  },

  // ── Suporte (sempre o último submenu do menu) ──────────────────────
  {
    name: 'Suporte',
    icon: 'bi-life-preserver',
    children: [
      {
        name: 'Chamados',
        url: '/suporte/chamados',
        icon: 'bi-card-checklist',
        requiredModules: ['SupportTickets'],
      },
    ],
  },
];
